import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useParams } from "react-router";
import { useGetCommissionsBatch } from "../../../../common/api/queries";
import { EntityIdObject } from "../../../../common/types";
import { CommissionsBatchDetailView } from "../components/CommissionsBatchDetailView";

export const CommissionsBatchDetailContainer = () => {
  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data: batch, isError } = useGetCommissionsBatch(id);

  return (
    <DisplayWrapper itemLoaded={!!batch} isError={isError}>
      {batch ? <CommissionsBatchDetailView batch={batch} /> : undefined}
    </DisplayWrapper>
  );
};
